export const sampleTokensVolume = [
  {
    color: '#ed1cb5',
    kdaReserve: { decimal: '1766767.508993318507' },
    name: 'KDA/KDX',
    percentage: 88.25317458876718,
    volumeUsd: 6819722.58471298,
  },
  {
    color: '#5dcbe5',
    kdaReserve: { decimal: '59674.509730911147' },
    name: 'KDA/ABC',
    percentage: 2.980847734008019,
    volumeUsd: 230343.6075578,
  },
  {
    color: '#92187B',
    kdaReserve: { decimal: '46254.271982961947' },
    name: 'KDA/XYZ',
    percentage: 2.310483026162522,
    volumeUsd: 178541.48985051998,
  },
  {
    name: 'OTHER',
    percentage: 6.45549465106228,
    volumeUsd: 249422.65744254997,
  },
];

export const samplePairsVolume = [
  {
    color: '#ed1cb5',
    name: 'KDA/KDX',
    percentage: 89.34946167893733,
    volumeKDA: 537113.6850825775,
    volumeUsd: 1036629.4122093746,
  },
  {
    color: '#5dcbe5',
    name: 'KDA/ABC',
    percentage: 1.854790964332884,
    volumeKDA: 11149.855759517672,
    volumeUsd: 21519.221615869104,
  },
  {
    color: '#ffa900',
    name: 'KDA/XYZ',
    percentage: 0.4569663445578795,
    volumeKDA: 2746.99894853487,
    volumeUsd: 5301.707970672299,
  },
  {
    name: 'OTHER',
    percentage: 8.33878101217191,
    volumeKDA: 50127.592426223884,
    volumeUsd: 96746.25338261209,
  },
];
